module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAE1SURBVHgB7Za9SgNBFEbvLIqNRVBRS3/BThsbCws7ESwEBTtLO30DxRcRsRU7sbKysNQmYBeJhUKKpEkRApmcmx+ySTUzYQcScuDsvQszfMzuzLIiE0Yd022stZuUM9xA7RdxWsKoYgnL+IWPxpiCpMLubPbctlZIc0G9lzgcJVzOJR6XukJ91gsSh6IGWo8JNZyRcBqJx+AiLuMuvkkYiXjssvf0TO4P8dt64rPCPjhXr7hFe4o/rvOCA1PBT7hK++wyfuhAhSc1R9lxGTtUIEE5vJH2hlpzmTMlAWgQ5QqvMecz1+ccVvAAj0OC0oH/1CWJQ0nfYV7ikdfAF4nHh+lsgE9ckWz5w71WR+g6Fmx2lFG/wb1fjE7wCWUft3EW5wfHOFLHX2mfT/3FeOBrVJEJY0ETdAZ4ZJ6oYoMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/renew_pc/youtube.png
// module id = IAmv
// module chunks = 0